import React, { useEffect, useState } from "react";
import "./TableOfContents.scss";

import { useSelector } from "react-redux";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { TableOfContentsElement } from "./components/TableOfContentsElement";

export default function TableOfContents(props) {
  const { part, pages } = props;

  const [headers, setHeaders] = useState([]);

  const {
    reportReducer: { layout, gridElements },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!layout.length || !gridElements.length) return;

    const addition = part === 1 ? 0 : 1;

    const newHeaders = gridElements
      ?.filter((item) => item.gridBoxType === "header")
      .map((item) => {
        const layoutEl = layout?.find((el) => el.i === item.label);

        if (layoutEl) {
          const { y } = layoutEl;

          return { ...item, y };
        }
        return item;
      })
      .sort((a, b) => a.y - b.y)
      .slice(20 * (part - 1) - addition, 20 * part - 1);

    setHeaders(newHeaders);
  }, [layout, gridElements]);

  return (
    <div id="table-of-contents-container" className="table-of-contents">
      {part === 1 && (
        <div className="table-of-contents__heading">
          <IDHFormattedMessage
            id="ws_table_of_contents"
            defaultMessage="Table of contents"
          />
        </div>
      )}

      {headers.map((item) => (
        <TableOfContentsElement key={item.label} data={item} pages={pages} />
      ))}
    </div>
  );
}
